<template>
  <div class="left-top">
    <div class="ltop">
      <div class="item">
        <div class="name">累计运动</div>
        <div class="val">
          <div class="fx-led">{{ data.all_user }}</div>
          <div class="unit">人</div>
        </div>
      </div>
      <div class="item">
        <div class="name">当日运动</div>
        <div class="val">
          <div class="fx-led">{{ data.today_user }}</div>
          <div class="unit">人</div>
        </div>
      </div>
      <div class="item">
        <div class="name">参与工会</div>
        <div class="val">
          <div class="fx-led">{{ data.company_num }}</div>
          <!-- <div class="fx-led">81</div> -->
          <div class="unit">家</div>
        </div>
      </div>
    </div>
    <div class="week">
      <div class="name">本周</div>
      <div class="line fx-led" :style="`width:${week_width}%`">{{ data.week_user }} <span>人</span></div>
    </div>
    <div class="week">
      <div class="name">上周</div>
      <div class="line fx-led prev" :style="`width:${last_week_width}%`">{{ data.last_week_user }} <span>人</span></div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    week_width() {
      if (this.data.week_user == 0) {
        return 12
      } else {
        if (this.data.week_user > this.data.last_week_user) {
          return 80
        } else {
          return 80 * (this.data.week_user / this.data.last_week_user)
        }
      }
    },
    last_week_width() {
      if (this.data.last_week_user == 0) {
        return 12
      } else {
        if (this.data.week_user < this.data.last_week_user) {
          return 80
        } else {
          return 80 * (this.data.last_week_user / this.data.week_user)
        }
      }
    },
  },
  props: {
    data: {
      default() {
        return {
          all_user: 0,
          today_user: 0,
          week_user: 0,
          last_week_user: 0,
        }
      },
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="less" scoped>
.left-top {
  padding: 20px;
  .ltop {
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    .item {
      background: #002874;
      width: 140px;
      height: 98px;
      padding: 15px;
      background: #002874;
      border-radius: 4px;
      .name {
        font-size: 18px;
        color: #ffffff;
        opacity: 0.65;
        font-weight: 600;
      }
      .val {
        font-size: 30px;
        color: #ffffff;
        font-weight: 700;
        margin-top: 10px;
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        .unit {
          font-size: 14px;
          color: #ffffff;
          font-weight: 400;
          opacity: 0.65;
        }
      }
    }
  }
  .week {
    margin-bottom: 12px;
    .name {
      opacity: 0.85;
      font-size: 18px;
      color: #ffffff;
    }
    .line {
      height: 40px;
      background: #2084ff;
      font-size: 30px;
      color: #ffffff;
      font-weight: 700;
      padding: 0px 6px;
      display: flex;
      align-items: baseline;
      justify-content: flex-end;
      span {
        font-size: 14px;
        color: #ffffff;
        font-weight: 400;
        opacity: 0.65;
        margin-left: 10px;
        display: block;
      }
      &.prev {
        background: #f7b500;
      }
    }
  }
}
</style>
